import React, { useState, useEffect } from 'react'
import BarChart from './UI/Chart/BarChart';
import PieChart from './UI/Chart/PieChart';
import LineChart from './UI/Chart/LineChart';
import BubbleChart from './UI/Chart/BubbleChart';
import ScatterChart from './UI/Chart/ScatterChart';
import RadarChart from './UI/Chart/RadarChart';
import PolarAreaChart from './UI/Chart/PolarAreaChart';
import DoughnutChart from './UI/Chart/DoughnutChart';
import ChartQueryModal from './ChartQueryModal';

const ChartDashboard = (props) => {
    const [isDataLoaded, setIsDataLoaded] = useState('false');
    const [chartData, setChartData] = useState([]);
    const [chartDataTemp, setChartDataTemp] = useState([]);

    const LaodChartData = (query, chartType) => {
        let model = {
            ChartType: chartType,
            SQLQuery: query,
        };

        fetch('api/Chart/LoadchartData', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            let colors = [];

            for (let i = 0; i < res.length; i++) {
                colors.push('#' + Math.floor(Math.random() * 16777215).toString(16));
            }

            if (res.length > 0) {
                var keys = [];
                for (var k in res[0]) keys.push(k);

                let labels = new Array();
                let dataSet = new Array();

                res.map((item, index) => {
                    labels.push(item[keys[0]]);
                });

                res.map((item, index) => {
                    dataSet.push(item[keys[2]]);
                });

                let data = {
                    chartType: chartType,
                    labels: labels,
                    datasets: [
                        {
                            label: 'Dataset for ' + chartType,
                            data: dataSet,
                            backgroundColor: colors,
                        }
                    ]
                }

                setChartData(data);
                if (chartDataTemp.length == 0) {
                    let arr = new Array();
                    arr.push(data);
                    setChartDataTemp(arr);
                }
                else {
                    let arr = chartDataTemp;
                    arr.push(data);
                    setChartDataTemp(arr);
                }

                setIsDataLoaded('true');
            }
        })
    };

    const dataBubble = {
        datasets: [
            {
                label: 'First Dataset',
                data: [{
                    x: 20,
                    y: 30,
                    r: 10
                }, {
                    x: 40,
                    y: 10,
                    r: 10
                }],
                backgroundColor: 'rgb(255, 99, 132)'
            },
            {
                label: 'Second Dataset',
                data: [{
                    x: 25,
                    y: 15,
                    r: 10
                }, {
                    x: 35,
                    y: 20,
                    r: 10
                }],
                backgroundColor: 'rgb(255, 123, 123)'
            }
        ]
    };

    const dataScatter = {
        datasets: [{
            label: 'Scatter Dataset',
            data: [{
                x: -10,
                y: 0
            }, {
                x: 0,
                y: 10
            }, {
                x: 10,
                y: 5
            }, {
                x: 0.5,
                y: 5.5
            }],
            backgroundColor: 'rgb(255, 99, 132)'
        }],
    };

    const dataRadar = {
        labels: [
            'Eating',
            'Drinking',
            'Sleeping',
            'Designing',
            'Coding',
            'Cycling',
            'Running'
        ],
        datasets: [{
            label: 'My First Dataset',
            data: [65, 59, 90, 81, 56, 55, 40],
            fill: true,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgb(255, 99, 132)',
            pointBackgroundColor: 'rgb(255, 99, 132)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255, 99, 132)'
        }, {
            label: 'My Second Dataset',
            data: [28, 48, 40, 19, 96, 27, 100],
            fill: true,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgb(54, 162, 235)',
            pointBackgroundColor: 'rgb(54, 162, 235)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(54, 162, 235)'
        }]
    };

    const dataPolarArea = {
        labels: [
            'Red',
            'Green',
            'Yellow',
            'Grey',
            'Blue'
        ],
        datasets: [{
            label: 'My First Dataset',
            data: [11, 16, 7, 3, 14],
            backgroundColor: [
                'rgb(255, 99, 132)',
                'rgb(75, 192, 192)',
                'rgb(255, 205, 86)',
                'rgb(201, 203, 207)',
                'rgb(54, 162, 235)'
            ]
        }]
    };

    const dataDoughnut = {
        labels: [
            'Red',
            'Blue',
            'Yellow'
        ],
        datasets: [{
            label: 'My First Dataset',
            data: [300, 50, 100],
            backgroundColor: [
                'rgb(255, 99, 132)',
                'rgb(54, 162, 235)',
                'rgb(255, 205, 86)'
            ],
            hoverOffset: 4
        }]
    };

    return (
        <div className="container-fluid">

            <div className="row" style={{ marginTop: "150px" }}>
                <div className="col-sm-2">
                    <ChartQueryModal style={{ "margin": "5px" }} header="Chart query" text="Load chart query" LaodChartData={LaodChartData}></ChartQueryModal>
                </div>
                <div className="col-sm-10">
                </div>
            </div>
            {
                chartDataTemp.map((item, index) =>
                    <>
                        <div key={"divBarChart_" + index} id={"divBarChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }} >
                            {isDataLoaded == 'true' && item.chartType == 'Bar' && <BarChart key={"divBarChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></BarChart>}
                        </div>
                        <div key={"divPieChart_" + index} id={"divPieChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }}>
                            {isDataLoaded == 'true' && item.chartType == 'Pie' && <PieChart key={"divBarChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></PieChart>}
                        </div>
                        <div key={"divLineChart_" + index} id={"divLineChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }}>
                            {isDataLoaded == 'true' && item.chartType == 'Line' && <LineChart key={"divBarChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></LineChart>}
                        </div>
                        <div key={"divBubbleChart_" + index} id={"divBubbleChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }}>
                            {isDataLoaded == 'true' && item.chartType == 'Bubble' && <BubbleChart key={"divBubbleChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></BubbleChart>}
                        </div>

                        <div key={"divScatterChart_" + index} id={"divScatterChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }}>
                            {isDataLoaded == 'true' && item.chartType == 'Scatter' && <ScatterChart key={"divScatterChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></ScatterChart>}
                        </div>

                        <div key={"divRadarChart_" + index} id={"divRadarChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }}>
                            {isDataLoaded == 'true' && item.chartType == 'Radar' && <RadarChart key={"divRadarChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></RadarChart>}
                        </div>

                        <div key={"divDoughnutChart_" + index} id={"divDoughnutChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }}>
                            {isDataLoaded == 'true' && item.chartType == 'Doughnut' && <DoughnutChart key={"divDoughnutChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></DoughnutChart>}
                        </div>

                        <div key={"divPolarAreaChart_" + index} id={"divPolarAreaChart_" + index} className="col-sm-4aa" style={{ width: "30%", display: "inline", float: "left", marginLeft: "25px" }}>
                            {isDataLoaded == 'true' && item.chartType == 'PolarArea' && <PolarAreaChart key={"divPolarAreaChart_" + index} chartData={item} height="500" width="500"
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: ''
                                        }
                                    }
                                }}></PolarAreaChart>}
                        </div>


                    </>
                )
            }
        </div>
    );
};

export default ChartDashboard;
